module.exports = __webpack_public_path__ + "img/dynamic6.33c4b0a2.png";